


















































import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { get } from 'lodash';
import slugify from '@/core/utils/slugify';
import { errorToMessage } from '@/core/utils/errors';
import { PageTemplate } from '@/core/typings/globals';

export default Vue.extend({
  components: {
    ValidationObserver,
  },
  props: {
    pageTemplate: {
      type: Object as () => PageTemplate,
      default: undefined,
    },
  },
  data() {
    return {
      form: {
        name: '',
        slug: '',
        page_palette_id: undefined,
      },
      formError: null,
    };
  },
  computed: {
    showPalettes() {
      return this.pageTemplate?.palettes?.length > 1;
    },
  },
  methods: {
    async createPage() {
      try {
        const data = {
          ...this.form,
          page_template_id: this.pageTemplate?.id,
        };
        const page = await this.$store.dispatch('page/createPage', data);
        this.$emit('close');
        this.$parent.$emit('onCreatePage', page.id);
      } catch (error) {
        this.formError = get(error, 'response.data.non_field_errors[0]', null);
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(
            error.response,
            `${this.$t('PAGES.NOTIFICATIONS.FAILED_TO_CREATE_PAGE')}: ${error}`
          ),
          duration: -1,
        });
      }
    },
    onTitleChange(title, isSlugPristine) {
      if (isSlugPristine) {
        this.form.slug = slugify(title);
      }
    },
  },
  mounted() {
    this.form.page_palette_id = this.pageTemplate?.palettes?.[0]?.id;
  },
});
